const ROUTES = {
  ROOT: '/',
  ACTIVITY: '/activity',
  INFORMATION: '/information',
};

export default ROUTES;
